import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService, CommonService, CommonAPIService } from '../../../services';
import { Paths } from '../../../enums';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-category-courses',
  standalone: false,
  templateUrl: './category-courses.component.html',
  styleUrl: './category-courses.component.scss'
})
export class CategoryCoursesComponent {
  courseCategoryData: any[] = [];
  imageUrl: string = environment.imageURL;

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getCoursesCategoryList();
  }

  async getCoursesCategoryList() {
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      const response: any = await this.commonAPIService.getCall('getCoursesCategoryActive', '');
      this.commonService.resetAPIFlag('getCoursesCategoryActive', false);
      switch (response.status) {
        case 1:
          if (response.data) {
            this.courseCategoryData = response?.data;
            this.sharedService.setApiCall(false);
          }
          else {
            this.courseCategoryData = [];
            this.sharedService.setApiCall(false);
          }
          break;
        case 0:
          this.courseCategoryData = [];
          this.sharedService.setApiCall(false);
          break;
      }
    } catch (error) {
      console.error('Error getting Courses details:', error);
    }
  }

  getSubCategory(item: any) {
    this.commonAPIService.data = item;
    localStorage.setItem('serviceData', JSON.stringify(item));
    this.router.navigate([`${Paths.courseSubCategory}`]);
  }
}
